import { Box, Checkbox, Tooltip, Typography } from '@mui/material';
import { makeStyles } from "@mui/styles";
import { DataGrid } from '@mui/x-data-grid';
import axios from 'axios';
import { debounce } from 'lodash';
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import actions from "../../Redux Store/actions";
import { updateAllotmentPayment } from '../../Services/AllAllotments';
import { dismissLoader, presentLoader } from '../../Services/loader';
import { errorTost } from '../../Services/Toast';
import Button from '../../Subcomponents/Button';
import ConfirmationAlert from '../../Subcomponents/ConfirmationAlert';
import DropDown from '../../Subcomponents/DropDown';
import LeadStatusChip from '../../Subcomponents/LeadStatusChip';
import SearchBar from '../../Subcomponents/Search';
import Dot from '../Icons/Dot';
import cssClasses from "./FarvisionAllotments.module.css";

const dataGridStyles = {
    "&.MuiDataGrid-root .MuiDataGrid-cell:focus": {
        outline: "none",
    },
    border: "1px solid #EAECF0 !important",
    fontWeight: "400",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    fontFamily: "Inter-Medium",
    borderRadius: "8px",
    '& div[data-colindex="1"]': {
        color: "#101828",
        fontWeight: "500",
    },
    "& .MuiDataGrid-virtualScrollerRenderZone": {
        "& .MuiDataGrid-row": {
            borderBottom: "1px solid #EAECF0",
            background: "#FFFFFF",
            /* Shadow/xl */

            // boxShadow: "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
            borderRadius: "1rem",

            //   "&:nth-of-type(2n+1)": { backgroundColor: "rgba(249, 250, 251, 1)" },
            //   backgroundColor: "#FFFFFF",
        },
        "& .MuiDataGrid-row.Mui-selected:hover": {
            borderBottom: "1px solid #EAECF0",
            backgroundColor: "#FFFFFF",
            // "&:nth-of-type(2n+1)": {
            //   backgroundColor: "rgba(249, 250, 251, 1)",
            // },
        },
    },
    "& .MuiDataGrid-iconSeparator ": {
        display: "none",
    },
    "& .MuiDataGrid-columnHeader:hover": {
        "& .MuiDataGrid-menuIcon": {
            visibility: "hidden",
        },
    },

    "&  .MuiDataGrid-columnHeaders": {
        background: "#F9FAFB",
        /* Gray/200 */
        border: "1px solid #EAECF0",
        /* Shadow/xl */
        // boxShadow:
        //   "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
        // borderRadius: "8px",

        marginBottom: "1rem",
        borderBottom: "6px solid #EAECF0",
    },
    "& .MuiDataGrid-columnSeparator": {
        display: "none",
    },
    "& .MuiDataGrid-checkboxInput": {
        "& svg": {
            width: "2rem",
            height: "2rem",
            background: "#FFFFFF",
        },
    },
    // "& .MuiTablePagination-displayedRows": {
    //   display: "none",
    // },
    "& .MuiDataGrid-footerContainer": {
        "& .MuiTablePagination-displayedRows ": {
            display: "none",
        },
        "& .MuiDataGrid-selectedRowCount": {
            visibility: "hidden ",
        },
    },
    "&  [title='Sort']": {
        //visibility:"hidden",
        display: "none",
        cursor: "none",
    },
    "& [title='Go to previous page']": {
        borderRadius: "0",
        border: "1px solid #EAECF0",
        borderRadius: "0.8rem",
        marginRight: "0.5rem",
    },
    "& [title='Go to next page']": {
        borderRadius: "0",
        border: "1px solid #EAECF0",
        borderRadius: "0.8rem",
        marginRight: "0.5rem",
    },
    "& [title='Go to previous page']:after": {
        content: "'Previous'",
        marginLeft: "1rem",
    },
    "& [title='Go to next page']:before": {
        content: "'Next'",
        marginRight: "1rem",
    },
    "& .MuiDataGrid-columnHeader": {
        padding: "0 4rem",

        "&:focus": {
            outline: "none",
        },
    },
    "&  .MuiDataGrid-row ": {
        maxHeight: "72px !important",
        minHeight: "72px !important",
    },
    "& .MuiDataGrid-cell": {
        padding: "0 4rem",
        minHeight: "72px !important",
        maxHeight: "72px !important",
        "&:focus": {
            outline: "none",
        },
    },
    "& .MuiButtonBase-root": {
        fontSize: "1.6rem",
    },
    "& .MuiDataGrid-cell:focus-within": {
        outline: "none !important",
    },
    "& .MuiDataGrid-cell": {
        padding: "0 2rem",
        minHeight: "72px !important",
        maxHeight: "72px !important",
        "&:focus": {
            outline: "none",
        },
    },
    "& .MuiDataGrid-columnHeader": {
        padding: "0 1rem",

        "&:focus": {
            outline: "none",
        },
    },
};

const useStyles = makeStyles((theme) => ({
    Tabs: {
        "&.MuiTabPanel-root": {
            padding: "0rem !important",
        },
    },
}));

export default function FarvisionAllotments() {
    const [allAllotments, setAllAllotments] = useState([]);
    const [crmUsers, setCrmUsers] = useState([]);
    const [crmUser, setCrmUser] = useState('');
    const [filterBy, setFilterBy] = useState("Latest First");
    const [showDropDown, setShowDropDown] = React.useState(false);
    const [selectedAllotments, setSelectedAllotments] = useState([]);
    const [search, setSearch] = useState("");
    const [openAlertBox, setOpenAlertBox] = React.useState(false);
    const classes = useStyles();
    const dispatch = useDispatch();
    const [currentPage, setCurrentPage] = useState(0);
    const [queryPage, setQueryPage] = useState(0);
    const [listsOrder, setListsOrder] = useState([
        "Name Ascending",
        "Name Descending",
        "Oldest First",
        "Latest First",
    ]);

    useEffect(() => {
        dispatch(actions.activeMenu("farvisionallotments"));
        getFilterAllotment()
    }, [queryPage])

    function getFilterAllotment() {
        presentLoader()
        // ! commented because unused now
        // axios.get(`https://labour.vjerp.com:4423/crmCustomer/getBookings?page=${queryPage + 1}&search=${search.toUpperCase()}`).then((resp) => {
        //     setAllAllotments((pre) => {
        //         return [...pre, ...resp.data.results];
        //     });
        //     console.log(...resp.data.results)
        //     dismissLoader()
        // }).catch((err) => {
        //     console.log(err)
        //     dismissLoader()
        // })
    }

    useEffect(() => {
        // ! commented because unused now
        // axios.get(`https://labour.vjerp.com:4423/crmCustomer/getCRMUsers`).then((resp) => {
        //     resp.data.results.forEach((ele) => {
        //         ele.label = ele.Name
        //         ele.value = ele.Name
        //     })
        //     console.log(resp.data.results)
        //     setCrmUsers([...resp.data.results]);

        // }).catch((err) => {
        //     console.log(err)
        // })
    }, [])

    const filterAllotmentBySort = (e) => {
        setFilterBy(e);
    };

    const debounceForSearch = debounce((e) => {
        searchUser(e)
        // console.log(e)
    }, 800);

    async function searchUser(e) {
        let searchData = e.target.value;
        setSearch(searchData);
        presentLoader()
        // ! commented because unused now
        // axios.get(`https://labour.vjerp.com:4423/crmCustomer/getBookings?page=${queryPage + 1}&search=${searchData.toUpperCase()}`).then((resp) => {
        //     setAllAllotments((pre) => {
        //         return [...resp.data.results];
        //     });
        //     console.log(allAllotments)
        //     dismissLoader()
        // }).catch((err) => {
        //     console.log(err)
        //     dismissLoader()
        // })
    }

    function pageChanged(e) {
        console.log(e);
        setCurrentPage(e);
        if (queryPage < e) {
            setQueryPage(e);
        }
    }

    const userGridColumns = [
        {
            field: "action",
            headerName: "",
            // flex: 1,
            width: 100,
            renderCell: (params) => {
                return (
                    <div className={cssClasses.actionDiv}>
                        <div>
                            {showDropDown &&
                                <Checkbox style={{ width: "2rem", height: "2rem" }} checked={selectedAllotments.includes(params.row.booking_id) ? true : false} onChange={(e) => {
                                    if (e.target.checked) {
                                        setSelectedAllotments((pre) => {
                                            pre.push(params.row.booking_id)
                                            return [...pre]
                                        })
                                    } else {
                                        setSelectedAllotments((pre) => {
                                            pre.splice(pre.findIndex((e) => e === params.row.booking_id), 1)
                                            return [...pre]
                                        })
                                    }
                                }} />
                            }
                            {/* <ThreeDotsMenu
                                // list={["Details", "Sync", "Check Status"]}
                                list={params.row.paidamount === 0 ? ["Check Status"] : ["Details", "Check Status"]}
                                selectedValue={(e) => { selectedValueCheck(e, params.row) }}
                            /> */}
                        </div>
                    </div>
                );
            },
        },
        {
            field: "booking_id",
            headerName: "Booking Id",
            flex: 1,
            width: 50,
        },
        {
            field: "auid",
            headerName: "AUID",
            flex: 1,
            with: 200,
        },
        {
            field: "name",
            headerName: "Name",
            flex: 1,
            with: 200,
            renderCell: (params) => {
                return (
                    <p>{params.row.first_name} {params.row.last_name}</p>
                )
            }
        },
        {
            field: "CRMUserId",
            headerName: JSON.parse(localStorage.getItem('user')).roleId?.accessibleTabs["All Allotments"]["Crm Users"]?.isAccessible ? "CRM User" : "",
            flex: 1,
            minWidth: 200,
            renderCell: (params) => {
                return (
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '1rem'
                    }}>
                        {JSON.parse(localStorage.getItem('user')).roleId?.accessibleTabs["All Allotments"]["Crm Users"]?.isAccessible &&

                            <DropDown list={crmUsers} selectedValue={(crmUsers.length > 0 && params.row.CRMUserId) ? crmUsers[crmUsers.findIndex((e) => e.Id === params.row.CRMUserId)].Name : ''} onChangeSelect={(e) => {
                                presentLoader()
                                // ! commented because unused now
                                // axios.post('https://labour.vjerp.com:4423/crmCustomer/UpdateCRMUserId', [{ booking_id: params.row.booking_id, crmUserId: crmUsers[crmUsers.findIndex((ele) => ele.label === e)].Id }]).then((resp) => {
                                //     setAllAllotments((pre) => {
                                //         console.log(pre.findIndex((e) => e.booking_id === params.row.booking_id))
                                //         pre[pre.findIndex((e) => e.booking_id === params.row.booking_id)].CRMUserId = crmUsers[crmUsers.findIndex((ele) => ele.label === e)].Id
                                //         pre[pre.findIndex((e) => e.booking_id === params.row.booking_id)].crmUser = e
                                //         return [...pre]
                                //     })
                                //     dismissLoader()
                                // }).catch((err) => {
                                //     dismissLoader()
                                // })
                            }} />
                        }
                    </div >
                )
            },
        },
    ]

    function ModalResp(e) {
        if (e === "confirmed") {
            presentLoader()
            let arr = []
            selectedAllotments.forEach((ele, index) => {
                arr.push({ booking_id: ele, crmUserId: crmUsers[crmUsers.findIndex((ele) => ele.label === crmUser)].Id })
                if (index === selectedAllotments.length - 1) {
                    // ! commented because unused now
                    // axios.post('https://labour.vjerp.com:4423/crmCustomer/UpdateCRMUserId', arr).then((resp) => {
                    //     console.log(resp)
                    //     setCrmUser("")
                    //     setShowDropDown(false)
                    //     setOpenAlertBox(false)
                    //     setQueryPage(0);
                    //     setCurrentPage(0);
                    //     setAllAllotments([])
                    //     getFilterAllotment();
                    //     dismissLoader()
                    // }).catch((err) => {
                    //     dismissLoader()
                    //     setAllAllotments([])
                    // })
                }
            })
        } else {
            setCrmUser("")
        }
    }

    function mainContent() {
        return (
            <div className={cssClasses.content}>
                {/* <Box display={"flex"} flexDirection={"column"} gap={"rem"}>
                    <Typography className={cssClasses.headerTittle}>{allAllotments.length} Allotments</Typography>
                </Box> */}
                <div className={cssClasses.actionWrapper}>
                    <div style={{ display: "flex", width: "50%" }}>
                        {/* <div
                            className={cssClasses.filterWrapper}
                            style={{
                                marginLeft: "8px",
                            }}
                        >
                            <div className={cssClasses.label}>
                                <p style={{ marginTop: "8px" }}>Sort by</p>
                            </div>
                            <div className={cssClasses.dropdownWrapper}>
                                <DropDown
                                    onChangeSelect={(e) => {
                                        filterAllotmentBySort(e);
                                    }}
                                    selectedValue={filterBy}
                                    style={{ selectedColor: "#175CD3", background: "#E8F0FE" }}
                                    list={listsOrder}
                                />
                            </div>
                        </div> */}
                    </div>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '2rem',
                        flexWrap: 'wrap'
                    }}>
                        {JSON.parse(localStorage.getItem('user')).roleId?.accessibleTabs["All Allotments"]["Crm Users"]?.isAccessible &&
                            <div>
                                {!showDropDown ?
                                    <Button style={{
                                        color: "#fff",
                                        backgroundColor: "#1570EF",
                                        fontSize: "1.4rem",
                                        lineHeight: "2rem",
                                        fontFamily: "Inter-Medium !important",

                                        // marginLeft: "-12px"
                                    }}
                                        btnName={"Bulk assign crm users"}
                                        // outline={true}
                                        clicked={() => setShowDropDown(true)}
                                        // btnIcon={<AddIcon style={{ width: "15px", height: "15px" }} />}
                                        iconPosition={"left"} />
                                    :
                                    <DropDown list={crmUsers} selectedValue={crmUser} onChangeSelect={(e) => {
                                        if (selectedAllotments.length > 0) {
                                            setCrmUser(e)
                                            setOpenAlertBox(true)
                                        } else {
                                            setCrmUser("")
                                            errorTost("Please select allotments first and then select crm user")
                                        }
                                    }} />
                                }
                            </div>
                        }
                        <div className={cssClasses.searchWrapper}>
                            <SearchBar
                                placeholder={"Search by Lead Name"}
                                search={debounceForSearch}
                                id={"userSearchBar"}
                            />
                        </div>
                    </div>
                </div>
                <div className={cssClasses.gridWrapper}>
                    {/* <Datagrid
                            pageChanged={pageChanged}
                            hideFooter={false}
                            currentPage={currentPage}
                            columns={userGridColumns}
                            rows={users.filter((e) => {
                                // if (subTabs.filter((ele) => { return ele.isSelected === true })[0].text === 'Pending') {
                                //     return e.paidamount === 0;
                                // } else if (subTabs.filter((ele) => { return ele.isSelected === true })[0].text === 'Complete') {
                                //     return e.paidamount === 500000;
                                // } else {
                                //     return e.paidamount < 500000 && e.paidamount > 0;
                                // }
                                return e
                            })}
                            quickFilterValues={['admin']}
                        // filterModel={filterModel}
                        /> */}
                    <DataGrid
                        rows={allAllotments.map((m, i) => ({ ...m, id: i }))}
                        // rows={allAllotments}
                        columns={userGridColumns}
                        pageSize={10}
                        rowsPerPageOptions={[10]}
                        page={currentPage}
                        onPageChange={(e) => {
                            pageChanged(e);
                        }}
                        sx={[dataGridStyles]}
                    />
                </div>
                {
                    openAlertBox &&
                    <ConfirmationAlert confirm={(e) => { ModalResp(e) }} buttonTitle={'Cancel'} returnRespButton={'Continue'} close={() => setOpenAlertBox(false)} title={'Warning'} subTitle={`Are you sure! Do you want to link crm user - ${crmUser}`} open={openAlertBox} />
                }
            </div>
        );
    }

    return (
        <div className={`pageWrapper ${cssClasses.pageWrapper}`}>
            <div style={{ height: "100%" }}>
                {mainContent()}
            </div>
        </div>
    )
}
